import { Box } from "@govlaunch/web";
import React from "react";
import CollectionCardForegroundIcon from "~/components/icons/Collections/CollectionCardForegroundIcon";

interface ICollectionCardForegroundProps {
  variant?: number | null;
}

export default function CollectionCardForeground({ variant }: ICollectionCardForegroundProps) {
  return (
    <Box position="absolute" top={0} left={0}>
      <CollectionCardForegroundIcon variant={variant} />
    </Box>
  );
}
